export const getWebMethods = {
    checkVersion: 'checkVersion',
    expenses: 'getExpenses',
    reqForApprovalMgr: 'getReqForApprovalMgr',
    userDetails: 'getUserDetails',
    userGrpProfile: 'getUserGrpProfile',
    deptCodes: 'getCodes',
    expItemsByDept: 'getExpItemsByDept',
    fiscalCalendar: 'getFiscalCalendar',
    deptBudgetDetails: 'getDeptBudgetDetails',
    generateReqId: 'getCodes',
    getCodes: 'getCodes',
    managersEmails: 'getManagers',
    preferredVendors: 'getPreferredVendors',
    saveLineItem: 'addExpense',
    savePoInfo: 'addExpense',
    vendorPartNoItems: 'getVendorItems',
    expDetailsByReqId: 'getExpDetailsByReqId',
    approveRequestByMgr: 'approveRequestByMgr',
    getComments: 'getComments',
    addComment: 'rejectComment',
    getReceivingPODetails: 'getReceivingPODetails',
    addPOReceiveMul: 'addPOReceiveMul'
};

export const addWebMethods = {

};